import React, { useState } from 'react'
import { Button, Col, FloatingLabel, Form, FormControl, Modal, Row } from 'react-bootstrap'
import { GetUsersByUserGroupOutput } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/models/getUserGroupModels';
import { CreateAppointmentInput, CreateUserAppointmentInput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/createAppointmentModels';
import moment from 'moment';
import { createUserAppointment } from '../../../../Adaptor/TUBSIS';
import AppointmentCreateWithNotExistUser from './AppointmentCreateWithNotExistUser';
import AppointmentCreateWithExistUser from './AppointmentCreateWithExistUser';

type Props = {appointmentStartDate: Date | null}

const AppointmentCreate: React.FC<Props> = ({ appointmentStartDate }) => {

    const handleAppointmentTypeSubmit = () => {
        if (createWithExistingUser) {
            // Var olan danışan için randevu oluştur popup'ını aç
            setShowExistingUserModal(true);
        } else if (createWithNewUser) {
            // Yeni bir danışan için randevu oluştur popup'ını aç
            setShowNewUserModal(true);
        }
        // Diğer durumlar için gerekli işlemleri buraya ekleyebilirsiniz
    };

    const closeAppointmentTypeModal = () => {
        setShowAppointmentTypeModal(false);
    };

    const openAppointmentTypeModal = () => {
        setShowAppointmentTypeModal(true);
    };

    const [showAppointmentTypeModal, setShowAppointmentTypeModal] = useState(false);
    const [showExistingUserModal, setShowExistingUserModal] = useState(false); // Yeni eklendi
    const [showNewUserModal, setShowNewUserModal] = useState(false); // Yeni eklendi
    const [createWithExistingUser, setCreateWithExistingUser] = useState(false);
    const [createWithNewUser, setCreateWithNewUser] = useState(false);

    return (
        <div className='text-end mt-2' >
            <input type='button' className='btn btn-primary' value={"RANDEVU OLUŞTUR"} onClick={openAppointmentTypeModal} />
            <Modal show={showAppointmentTypeModal} onHide={closeAppointmentTypeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Hangi Tipte Randevu Oluşturmak İstersiniz?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleAppointmentTypeSubmit}>
                        <Row className="mb-3 text-gray-900">
                            <Form.Group as={Col}>
                                <Form.Check
                                        type="checkbox"
                                        id="createWithExistingUser"
                                        label="Sistemde kayıtlı bir danışan için randevu oluştur."
                                        name="createWithExistingUser"
                                        checked={createWithExistingUser}
                                        onChange={() => {
                                            setCreateWithExistingUser(true);
                                            setCreateWithNewUser(false);
                                        }}
                                    />
                            </Form.Group>

                            <Form.Group as={Col}>
                                <Form.Check
                                        type="checkbox"
                                        id="createWithNewUser"
                                        label="Yeni bir danışan için randevu oluştur."
                                        name="createWithNewUser"
                                        checked={createWithNewUser}
                                        onChange={() => {
                                            setCreateWithExistingUser(false);
                                            setCreateWithNewUser(true);
                                        }}
                                    />
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeAppointmentTypeModal}>
                        Kapat
                    </Button>
                    {createWithExistingUser ? <AppointmentCreateWithExistUser propAppointmentStartDate={appointmentStartDate}/> : 
                                              <AppointmentCreateWithNotExistUser propAppointmentStartDate={appointmentStartDate}/>}
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default (AppointmentCreate)